'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyframes = undefined;

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props, traits, keyframes) {
  var isDisabled = props.isDisabled,
      isLoading = props.isLoading,
      styles = props.styles;
  var colors = traits.colors,
      radiuses = traits.radiuses,
      rhythm = traits.rhythm;

  var isInactive = isDisabled || isLoading;

  var defaultStyles = {
    root: {
      display: 'block',
      margin: 'auto',
      paddingBottom: rhythm(1.5)
    },

    fields: {
      opacity: isLoading && 0.3,
      pointerEvents: isLoading && 'none'
    },

    error: {
      margin: rhythm([1, 0]),
      padding: rhythm([0.5, 0.75]),
      backgroundColor: colors.danger,
      fontWeight: 'bold',
      color: colors.light,
      borderRadius: rhythm(radiuses.small),

      '& p + p': {
        marginTop: rhythm(0.666)
      },

      '& a': {
        color: colors.tertiary
      }
    },

    action: {
      backgroundColor: colors.transparent,
      color: colors.primary
    },

    submit: {
      opacity: isInactive ? '0.3 !important' : 0.85,
      paddingLeft: rhythm(1.25),
      paddingRight: rhythm(1.25),
      transition: 'all 250ms ease',

      '&:focus': {
        opacity: isInactive ? '0.3 !important' : 1,
        boxShadow: '0 0 15px 1px rgba(0, 0, 0, 0.25)'
      },

      '&:active': {
        opacity: isInactive ? '0.3 !important' : 1,
        boxShadow: 'inset 0 0 15px 1px rgba(0, 0, 0, 0.25)'
      },

      '&:hover': {
        opacity: isInactive ? '0.3 !important' : 1,
        cursor: isInactive ? 'default' : 'pointer',
        pointerEvents: isInactive ? 'none' : 'all'
      },

      '&:after': {
        content: '""',
        display: isLoading ? 'inline-block' : 'none',
        width: rhythm(0.75),
        height: rhythm(0.75),
        marginLeft: rhythm(0.5),
        marginRight: rhythm(-0.5),
        borderRadius: '50%',
        border: '2px solid transparent',
        borderRightColor: colors.light,
        textIndent: '-9999px',
        overflow: 'hidden',
        animation: keyframes.spin + ' 1s linear infinite'
      }
    },

    icon: {
      display: isLoading && 'none'
    }
  };

  return (0, _merge2.default)(defaultStyles, styles);
};

var keyframes = exports.keyframes = {
  spin: {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/form/styles.js
// module id = 837
// module chunks = 0